// Smart API base URL detection
// - On production (vladriver-vtc.fr): use same-origin /api (avoids cross-domain cookie blocking)
// - On preview / dev: use REACT_APP_BACKEND_URL
export const getApiBase = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "vladriver-vtc.fr" || host === "www.vladriver-vtc.fr") {
      return `${window.location.origin}/api`;
    }
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiBase();
